/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { VenueDistance } from '@app/shared/components/venue-distance/venue-distance.model';
import { Logger } from '@app/core';
import { Venue } from '@app/settings/venues/venue.model';
import { DistanceService } from '@app/core/distance/distance.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
// import { DistanceService } from '@app/core/distance/distance.service';

const log = new Logger('VenueDistanceComponent');

@Component({
  selector: 'app-venue-distance',
  templateUrl: './venue-distance.component.html',
  styleUrls: ['./venue-distance.component.scss'],
})
export class VenueDistanceComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() distance: object = null;

  public static getEmpty(venueId: number = null): FormGroup {
    return new FormGroup({
      id: new FormControl(venueId),
      distance: new FormControl(''),
      note: new FormControl(null),
      venue: new FormControl(null),
    });
  }

  /**
   * Създава много контакти от модел
   * @param venuesDistances Взима броя на venuesDistances и прави празени за всеки
   */
  public static createMany(venuesDistances: Array<VenueDistance>): FormArray {
    const formArray: FormArray = new FormArray([]);
    venuesDistances.forEach((venue: any) => {
      formArray.push(VenueDistanceComponent.getEmpty());
    });
    return formArray;
  }

  constructor(
    private distanceService: DistanceService,
    private translate: TranslateService,
    private toastr: ToastrService
  ) {}

  // constructor() {
  // }

  ngOnInit() {
    setTimeout(() => {
      // @ts-ignore
      // if (this.parentFormGroup.controls.venues.length <= 0) {
      //   this.addVenue();
      // }
    });
  }

  addVenue() {
    // @ts-ignore
    this.parentFormGroup.controls.venues.push(VenueDistanceComponent.getEmpty());
  }

  removeVenue(index: number) {
    // @ts-ignore
    this.parentFormGroup.controls.venues.controls.splice(index, 1);
    this.parentFormGroup.controls.venues.updateValueAndValidity();
  }

  getRoadDistance(venue: Venue, index: number, lat: number, long: number) {
    log.debug('getRoadDistance', venue, index, lat, long);
    if (venue && venue.lat && venue.long && lat && long) {
      log.debug(venue.lat, venue.long, lat, long);
      this.distanceService
        .getRoadDistance(
          {
            lat: venue.lat,
            long: venue.long,
          },
          {
            lat: lat,
            long: long,
          }
        )
        .subscribe(
          (response: any) => {
            log.debug('res', response);

            this.parentFormGroup.get('venues')['controls'][index].get('distance').patchValue(response);
          },
          (error) => {
            log.error(error);
            this.toastr.error(error);
          }
        );
    } else {
      log.error('invalid data');
    }
  }

  changeVenue(venue: Venue, index: number) {
    this.parentFormGroup.get('venues')['controls'][index].get('venue').patchValue(venue);
  }

  fillDistance(index: number) {
    // @ts-ignore
    const venue = this.parentFormGroup.get('venues').controls[index].get('venue').value;
    this.getRoadDistance(venue, index, this.parentFormGroup.get('lat').value, this.parentFormGroup.get('long').value);
  }

  fillAllDistances() {
    const startCoordinates: Array<any> = [];
    const endCoordinates: object = {
      lat: this.parentFormGroup.get('lat').value,
      long: this.parentFormGroup.get('long').value,
    };

    // @ts-ignore
    this.parentFormGroup.get('venues').controls.forEach((venue: FormControl) => {
      if (
        venue.get('venue') &&
        venue.get('venue').value &&
        venue.get('venue').value.lat &&
        venue.get('venue').value.long
      ) {
        startCoordinates.push({ lat: venue.get('venue').value.lat, long: venue.get('venue').value.long });
      }
    });
    log.debug('startCoordinates', startCoordinates);
    if (startCoordinates.length <= 0) {
      this.translate.get('VENUE_DISTANCE.NO_VENUES_TO_FILL_DISTANCE_MSG').subscribe((res: string) => {
        this.toastr.error(res);
      });
      return false;
    }
    this.distanceService.getMultipleRoadDistances(startCoordinates, endCoordinates).subscribe((res: any) => {
      // @ts-ignore
      this.parentFormGroup.get('venues').controls.forEach((venue: FormControl, index: number) => {
        if (
          venue.get('venue') &&
          venue.get('venue').value &&
          venue.get('venue').value.lat &&
          venue.get('venue').value.long
        ) {
          venue.get('distance').patchValue(res[index]);
          if (typeof res[index] !== 'number') {
            this.toastr.success('Error |' + res[index] + '| at' + venue.get('venue').value.name);
          }
        }
      });
    });
  }
}
